import { connect, useDispatch } from "react-redux";
import {
  getAllStudentType,
  getAllVersion,
} from "../../../../../../action/common/commonActionCreator";
import { IFreshmanConfigurationData, IFreshmanConfigurationView } from "../../../../../../models/freshman/configuration";
import { useEffect, useState } from "react";
import FloatingLabelDropDown from "../../../../../../common-components/floatingdropdown";
import { getAllInactiveVersion } from "../../../../../../action/freshman/configurationActionCreator";
import { setInactiveVersion } from "../../../../../../store/slices/freshman/inactiveVersionSlice";
import { setConfigurations } from "../../../../../../store/slices/freshman/configurationSlice";
import LoaderSpinner from "../../../../../../common-components/loader";

const FreshmanConfigurationView = (props: IFreshmanConfigurationView) => {
  const {
    studentTypes,
    configurationData,
    setShowView,
    getAllConfiguration,
    getAllVersions,
    version = [],
    getInActiveVersion,
    inactiveVersion
  } = props;


  const [selectedStep, setSelectedStep] = useState<number>(0);
  const [activeClass, setActiveClass] = useState("");
  const [selectedVersion, setSelectedVersion] = useState<number | null | undefined>(configurationData.versionId);
  const [data, setData] = useState<IFreshmanConfigurationData>(configurationData);
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const dispatch = useDispatch();

  // useEffect(() => {
  //   if (selectedVersion != Math.max(...version)) {
  //     setData(inactiveVersion);
  //   } else {
  //     setData(configurationData);
  //   }
  // }, [selectedVersion, inactiveVersion]);

  useEffect(() => {
    console.log(data);

    if (data?.mainSteps) {
      setActiveClass(
        selectedStep === data.mainSteps.find(ms => ms.mainStepId === selectedStep)?.mainStepId
          ? "active-item-fresh"
          : ""
      );
    }
  }, [selectedStep, data?.mainSteps]);

  const onClick = (id: number) => {
    if (id === selectedStep) {
      setSelectedStep(0);
      setIsLoading(false);
    } else {
      setSelectedStep(id);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (configurationData.id != null) {
      getAllVersions(configurationData?.id);
    }
  }, [])

  const onChange = async (
    event:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLSelectElement>
      | React.ChangeEvent<HTMLTextAreaElement>
  ) => {
    setSelectedVersion(Number(event.target.value));
    setIsLoading(true)
    try {
      if (configurationData.id != null && selectedVersion != null) {
        await getInActiveVersion(configurationData.id, Number(event.target.value));
      }
    } finally {
      setIsLoading(false)
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setInactiveVersion([]));
      dispatch(setConfigurations([]))
    };
  }, []);

  return (
    <>
      <div className="modal-header">
        <h1 className="modal-title fs-5" id="addnewbuttonsLabel">
          Configuration
        </h1>
        <div className="d-flex justify-content-end align-items-center gap-3">
          <FloatingLabelDropDown
            label={"Version"}
            onChange={onChange}
            isMandatory={false}
            name="version"
            value={selectedVersion || []}
            optionsList={version?.map(v => ({ id: v.toString(), name: v }))}
            showClear={false}
            showFilter={false}
          />
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              setShowView(false);
              getAllConfiguration();
            }}
          ></button>
        </div>
      </div>
      <div className="modal-body">
        <div className="accordion-container">
          <div className="pgm-dtls">
            <h6>
              Program level:{" "}
              <strong>
                {
                  studentTypes?.find(
                    (st) => st.id === data?.studentType
                  )?.name
                }
              </strong>
            </h6>
            <h6>
              International student:{" "}
              <strong>
                {data?.isInternational ? "Yes" : "No"}
              </strong>
            </h6>
            <h6>
            College:{" "}
              <strong>
                {
                  data?.collegeName
                }
              </strong>
            </h6>
          </div>
          {isLoading ? (
            <LoaderSpinner />
          ) : (
            <ul id="accordion" className="accordion ui-accordion">
              {/* {data?.mainSteps?.map((ms, index) => (
              <li
                className="accordion-item"
                onClick={() => onClick(ms.mainStepId ?? 0)}
              >
                <div
                  className={`header ui-accordion-header ps-2 ${activeClass}`}
                  style={{
                    backgroundColor:
                      selectedStep === ms.mainStepId
                        ? "#948256"
                        : "transparent",
                  }}
                >
                  <span className="order-number">{index + 1} </span>{" "}
                  {ms.mainStepName}
                  <div className="arrow-acc">
                    <img src="/assets/images/icon/arrow-right.svg" alt="" />
                  </div>
                </div>
                {selectedStep === ms.mainStepId && (
                  <div className="content ui-accordion-content">
                    <h2 className="text-dark">
                      Step {index + 1} :{" "}
                      {
                        ms?.mainStepName
                      }
                    </h2>
                    <p>
                      {
                        ms?.description
                      }
                    </p>
                    {ms?.prerequisites && ms.prerequisites.length > 0 && ( */}
              {
                configurationData?.mainSteps?.map((ms, index) => {
                  const isActive = selectedStep === ms.mainStepId;
                  return (
                    <li
                      key={ms.mainStepId}
                      className="accordion-item"
                      onClick={() => onClick(ms.mainStepId ?? 0)}
                    >
                      <div
                        className={`header ui-accordion-header ps-2 ${isActive ? "active-item-fresh" : ""}`}
                        style={{
                          backgroundColor: isActive ? "#948256" : "transparent",
                        }}
                      >
                        <span className="order-number">{index + 1} </span>{" "}
                        {ms.mainStepName}
                        <div className="arrow-acc">
                          <img src="/assets/images/icon/arrow-right.svg" alt="" />
                        </div>
                      </div>
                      {isActive && (
                        <div className="content ui-accordion-content">
                          <h2 className="text-dark">
                            Step {index + 1} : {ms?.mainStepName}
                          </h2>
                          <p>{ms?.description}</p>
                          {ms?.prerequisites && ms.prerequisites.length > 0 && (
                            <h4>
                              Predecessors:{" "}
                              {ms.prerequisitesNames?.join(", ")}
                            </h4>
                          )}
                          <ul className="sub-item-list">
                            {ms?.subSteps?.map((ss, subIndex) => (
                              <li key={subIndex} className="sub-item">
                                <span className="order-number">{subIndex + 1}</span>
                                <div className="dtls">
                                  <h6 className="text-dark">
                                    <a>{ss?.name}</a>
                                  </h6>
                                  <p>{ss?.description}</p>
                                  {ss?.prerequisites && ss.prerequisites.length > 0 && (
                                  <h4>
                                    Predecessors:{" "}
                                    {ss.prerequisitesNames?.join(", ")}
                                  </h4>
                                  )}
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      )}
                    </li>
                  );
                })
              }
            </ul>
          )}
        </div>
      </div >
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={() => {
            setShowView(false);
            getAllConfiguration();
          }}
        >
          Close
        </button>
      </div>
    </>
  );
};


const mapDispatchToProps = {
  getAllStudentType: getAllStudentType,
  getAllVersions: (id: number) => getAllVersion(id),
  getInActiveVersion: (studentCateogry: number, versionId: number) => getAllInactiveVersion(studentCateogry, versionId)
};

function mapStateToProps(state: any) {
  return {
    studentTypes: state.common.studentType,
    version: state.common.version,
    inactiveVersion: state.inactiveVersion.inactiveVersion
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FreshmanConfigurationView);
